<template>
  <div
    class="menuListDialog"
    v-if="currThemeObj"
    :style="{
      '--mixtmt_publicThemeDialog_cardBgColor':
        currThemeObj.cssStyle.publicThemeDialog_cardBgColor,
    }"
  >
    <div class="dialog_pop" v-show="isShowFlag" @click.stop="closePop()"></div>
    <div
      class="dialog_card_bg"
      v-show="isShowFlag"
      :style="{
        width: dialogObj && dialogObj.cardWH ? dialogObj.cardWH[0] : '80%',
      }"
    >
      <div class="dialog_card">
        <div class="dialogCard_header">
          <span
            class="dialog_title"
            v-text="
              dialogObj && dialogObj.dialogText ? dialogObj.dialogText : ''
            "
          ></span>
          <slot name="headerBtn"></slot>
        </div>
        <div
          class="toast_warning"
          :class="dialogTipObj && dialogTipObj.tipText ? 'slideT2B' : ''"
        >
          <span class="errorTipTextIcon el-icon-circle-close"></span>
          <span
            class="errorTipText"
            v-text="
              dialogTipObj && dialogTipObj.tipText ? dialogTipObj.tipText : ''
            "
          ></span>
        </div>
        <div class="dialogCard_body">
          <span class="dialogCard_body_left">
            <span
              class="menuList"
              :style="{
                height:
                  dialogObj && dialogObj.cardWH ? dialogObj.cardWH[1] : '70vh',
              }"
            >
              <span
                class="menuList_item"
                v-for="menuItem in menuList"
                :key="menuItem.type"
                :class="menuItem.act ? 'act' : ''"
                @click="clickMenuItem(menuItem)"
              >
                <span class="actBgColor"></span>
                <span class="menuName" v-text="menuItem.name"></span>
              </span>
            </span>
          </span>
          <span
            class="dialogCard_body_right"
            :style="{
              height:
                dialogObj && dialogObj.cardWH ? dialogObj.cardWH[1] : '70vh',
            }"
          >
            <slot name="bodyRight"></slot>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- 菜单列表弹窗 -->
<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'menuListDialog',
  mixins: [cup_base_data_mixin],
  props: {
    isShowFlag: {
      type: Boolean,
      default: false,
    },
    dialogObj: {
      type: Object,
      default: () => ({
        cardWH: ['60%', '50vh'],
        dialogText: '',
      }),
    },
    menuList: {
      type: [Array, null],
      default: null,
      // default: () => {
      //   return [
      //     {
      //       type: 'singleAddItem',
      //       name: '单个添加',
      //       act: true,
      //     },
      //     {
      //       type: 'batchUpload',
      //       name: '批量上传',
      //       act: false,
      //     },
      //   ]
      // },
    },
    dialogTipObj: {
      type: [Object, null],
      default: () => ({
        type: '',
        tipText: '',
      }),
    },
  },
  data() {
    return {
      // menuList: [],
      // errorTipText: '',
    }
  },
  created() {
    console.debug('created menuListDialog:')
    this.init()
  },

  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    closePop() {
      // 这里是触发分享弹窗事件
      console.debug('closePop')
      this.$emit('closePopEvent', {
        isClosePop: false,
      })
    },
    clickMenuItem(actItem) {
      this.$emit('clickMenuItemEvent', actItem)
    },
  },
}
</script>

<style lang="scss">
.menuListDialog {
  .dialog_pop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1600;
    background-color: var(--mixtmt_greyColor2);
    width: 100%;
    height: 100%;
  }
  .dialog_card_bg {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1610;
    background-color: var(--mixtmt_publicThemeDialog_cardBgColor);
    width: 80%;
    height: auto;
    transform: translate(-50%, -50%);
    border-radius: 1.25vw;
    overflow: hidden;
    .dialog_card {
      --dialog_card_size: 4.16vw;
      position: relative;
      width: 100%;
      height: auto;
      padding-top: var(--dialog_card_size);
      .dialogCard_header {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        background-color: var(--mixtmt_whiteColor);
        width: 100%;
        padding: 0 2%;
        height: var(--dialog_card_size);
        border-bottom: 1px solid var(--mixtmt_greyColor0);
        .dialog_title {
          font-size: 1.1vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor2);
        }
      }
      .toast_warning {
        position: absolute;
        top: var(--dialog_card_size);
        left: 10%;
        z-index: 8;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--mixtmt_errColor);
        width: 80%;
        padding: 0.694vw 2%;
        height: auto;
        color: var(--mixtmt_whiteColor);
        font-size: 0.974vw;
        line-height: 1.1vw;
        border-radius: 0 0 calc(var(--dialog_card_size) / 3)
          calc(var(--dialog_card_size) / 3);
        transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        -webkit-transform: translateY(-100%);
        transform: translateY(-100%);
        &.slideT2B {
          -webkit-transform: translateY(0);
          transform: translateY(0);
        }
        .errorTipTextIcon {
          width: 1.388vw;
          height: 1.388vw;
          font-size: 1.38vw;
          color: var(--mixtmt_whiteColor);
        }
        .errorTipText {
          padding: 0 0.694vw;
        }
      }
      .dialogCard_body {
        width: 100%;
        height: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        .dialogCard_body_left {
          width: 20%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          border-right: 1px solid var(--mixtmt_greyColor0);
          .menuList {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            width: 100%;
            padding: calc(2.2vw + 2%) 5%;
            height: 50vh;
            overflow: auto;
            background-color: var(--mixtmt_whiteColor);
            .menuList_item {
              position: relative;
              margin-top: 5%;
              width: 100%;
              height: 2.68vw;
              border-radius: 0.22vw;
              background-color: var(--mixtmt_publicThemeDialog_cardBgColor);
              &.act {
                .actBgColor {
                  width: 100%;
                }
                .menuName {
                  color: var(--mixtmt_whiteColor);
                }
              }
              .actBgColor {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 5;
                width: 0.32vw;
                height: 100%;
                border-radius: 0.22vw;
                background-color: var(--mixtmt_mainColor);
                transition: width 0.3s linear;
              }
              .menuName {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 10;
                width: 100%;
                height: 100%;
                text-align: center;
                color: var(--mixtmt_greyColor2);
                font-weight: bold;
                font-size: 0.974vw;
                line-height: 2.68vw;
                transition: color 0.3s linear;
              }
            }
          }
        }
        .dialogCard_body_right {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          width: 80%;
          height: 70vh;
          padding: 2%;
          overflow: auto;
        }
      }
    }
  }
}

.mixtmt_pc .menuListDialog {
  .dialog_card_bg {
    .dialog_card {
      .dialogCard_body {
        .menuList {
          .menuList_item {
            background-color: var(--mixtmt_publicThemeDialog_cardBgColor);
            &:hover {
              cursor: pointer;
              .actBgColor {
                width: 100%;
              }
              .menuName {
                color: var(--mixtmt_whiteColor);
              }
            }
          }
        }
      }
    }
  }
}
</style>
